import React, { useCallback, useEffect, useState } from "react";
import "../../../css/print.css"
import { useParams } from "react-router-dom";
import api from "../../../api/api";

export default function AttestedToPrint() {

    const { patientId, attestedId } = useParams();

    const [attestedToPrint, setAttestedToPrint] = useState('');

    const getAttestedToPrint = useCallback(() => {
        api.get(`/atestado/${patientId}/${attestedId}/print`, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setAttestedToPrint(returnFromApi.data);
        })
            .catch((returnFromApi) => {
                console.error("ops! ocorreu um erro" + returnFromApi);
            });
    }, [attestedId, patientId]);

    useEffect(() => {
        getAttestedToPrint();

        const handleAfterPrint = () => {
            window.close();
        };
        document.body.classList.add("printing-active");
        window.addEventListener("afterprint", handleAfterPrint);

        const timer = setTimeout(() => {
            window.print();
        }, 500);

        return () => clearTimeout(timer);
    }, [getAttestedToPrint]);

    return (
        <div className="container d-none d-print-block">
            <div className="text-center mt-5">
                <h5>ATESTADO</h5>
            </div>

            <div
                className={attestedToPrint.tipoDeAtestadoValue === 'REPOUSO' ? 'd-none d-print-block mt-5' : 'd-print-none'}>
                <p>Atesto, com o fim específico de dispensa de atividades trabalhistas (ou escolares, judiciárias),
                    que o (a) paciente {attestedToPrint.nomeDoPaciente} esteve sob meus cuidados profissionais no
                    dia {attestedToPrint.data} devendo permanecer em repouso
                    por {attestedToPrint.quantidadeDeDiasDeRepouso} dia(s).</p>
            </div>

            <div
                className={attestedToPrint.tipoDeAtestadoValue === 'COMPARECIMENTO' ? 'd-none d-print-block mt-5' : 'd-print-none'}>
                <p>Atesto, com o fim específico de dispensa de atividades trabalhistas (ou escolares, judiciárias),
                    que o (a) paciente {attestedToPrint.nomeDoPaciente} esteve sob meus cuidados profissionais no
                    dia {attestedToPrint.data},
                    no período de {attestedToPrint.horaInicial} horas
                    às {attestedToPrint.horaFinal} horas.</p>
            </div>

            <div className="text-center mt-5">
                <p>Atenciosamente,</p>
                <p>{attestedToPrint.nomeDoDentista}</p>
            </div>

            <div className="text-center mt-5">
                <p>Autorização</p>
                <p>Eu, ___________________________________________</p>
                <p>autorizo que meu diagnóstico(CID) esteja presente nesse atestado.</p>
                <p>CID: {attestedToPrint.cid}</p>
            </div>
        </div>
    );
}